module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "availability"
  }, [_c('div', {
    staticClass: "window p-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "bold mb-3"
  }, [_vm._v("Date range")]), _vm._v(" "), _c('date-range', {
    attrs: {
      "from": _vm.dateFrom,
      "to": _vm.dateTo,
      "fromLabel": "From",
      "toLabel": "To",
      "disabledTo": _vm.disabledTo
    },
    on: {
      "setFrom": _vm.setFrom,
      "setTo": _vm.setTo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mt-5 ml-auto"
  }, [_c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAvailability
    }
  }, [_vm._v("Check Availability")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b52a6bd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Availability.vue
// module id = 1558
// module chunks = 0